import type * as React from "react";

type GradientDotsProps = React.HTMLAttributes<HTMLDivElement>;

export function GradientDots({ className, ...props }: GradientDotsProps) {
  return <div className={["gradient-dots", className].filter(Boolean).join(" ")} {...props} />;
}
